import { api } from './client'

// ---------- tipuri — oglindesc DTO-urile din Cipral.Application/Achizitii/ReceptiiModels.cs ----------

export type GoodsQualityStatus = 'Acceptat' | 'InControl' | 'Respins'

export interface GoodsReceiptLine {
  id: string | null
  purchaseOrderLineId: string
  articleId: string
  articleCode: string
  articleDescription: string
  quantityReceived: number
  lotNumber: string | null
  zoneId: string | null
  zoneName: string | null
  locationId: string | null
  locationCode: string | null
  qualityStatus: GoodsQualityStatus
}

export type SaveGoodsReceiptLinePayload = Pick<
  GoodsReceiptLine, 'purchaseOrderLineId' | 'quantityReceived' | 'lotNumber' | 'zoneId' | 'locationId' | 'qualityStatus'
>

export interface GoodsReceiptListItem {
  id: string
  number: string
  receivedDate: string
  createdAt: string
  purchaseOrderId: string
  purchaseOrderNumber: string
  supplierId: string
  supplierName: string
  warehouseId: string
  warehouseName: string
  receivedByUserName: string
}

export interface GoodsReceiptDetail {
  id: string
  number: string
  receivedDate: string
  purchaseOrderId: string
  purchaseOrderNumber: string
  warehouseId: string
  warehouseName: string
  receivedByUserName: string
  notes: string | null
  lines: GoodsReceiptLine[]
}

export interface SaveGoodsReceiptPayload {
  receivedDate: string
  purchaseOrderId: string
  warehouseId: string
  notes: string | null
  lines: SaveGoodsReceiptLinePayload[]
}

export const listGoodsReceipts = () => api.get<GoodsReceiptListItem[]>('/achizitii/receptii').then((r) => r.data)
export const getGoodsReceipt = (id: string) => api.get<GoodsReceiptDetail>(`/achizitii/receptii/${id}`).then((r) => r.data)
export const createGoodsReceipt = (payload: SaveGoodsReceiptPayload) =>
  api.post<{ id: string }>('/achizitii/receptii', payload).then((r) => r.data)
